import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const tk = localStorage.getItem("se_admin_token");
  if (tk) cfg.headers.Authorization = `Bearer ${tk}`;
  return cfg;
});

export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export const errMsg = (e, fallback = "Error") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};

export const CONTACT_EMAIL = "info@thestoneedition.com";
export const INSTAGRAM_URL = "";
